import { FC, useEffect, useState } from 'react'

import { Button, Card, FormMessageError, Icon, Loading, Paginate, Table, Text, Title } from '../../UI'
import { Modal, useModal } from '../../UI/Modal'
import { appointmentService } from '../../../services'
import { FamilyGroupFilter } from '..'

type MedicalAppointmentsUpcomingsProps = {
  data: any,
  familyFilter: any,
  familyFilterSelected: string,
  onDataReload?(patientId: string): void
}

const pageDefault: number = 1
const pageSizeDefault: number = 5

const TableLabel:FC = ({ children }) => <Text component="label" color="primary" size="14">{children}</Text>

const TableText:FC = ({ children }) => <Text component="span" size="14">{children}</Text>

const MedicalAppointmentsUpcomings:FC<MedicalAppointmentsUpcomingsProps> = ({ data, familyFilter, familyFilterSelected, onDataReload }) => {
  const [pageCurrent, setPageCurrent] = useState<number>(pageDefault)
  const [tableItemsShow, setTableItemsShow] = useState<boolean[]>([false, false, false, false, false, false, false, false, false, false])
  const [dataPage, setDataPage] = useState<any[] | ''>('')
  const [appointmentSel, setAppointmentSel] = useState<any>()
  const [patientId, setPatientId] = useState<string>('')
  const modal = useModal()

  useEffect(() => {
    setDataPageCurrent(pageDefault)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const tableColumns = [
    {
      accessor: 'doctor_name',
      Header: 'Profesional',
      width: '30%',
      Cell: (params: any) => {
        const { original } = params.row

        return (
          <>
            <span className="d-block">{original.doctor_name}</span>
            <span className="d-block fz-12 mt-5">{original.specialty} - {original.sub_context}</span>
          </>
        )
      }
    },
    {
      accessor: 'date',
      Header: 'Fecha',
      width: '15%'
    },
    {
      accessor: 'hour',
      Header: 'Hora',
      width: '15%'
    },
    {
      accessor: 'place_care',
      Header: 'Sucursal',
      width: '25%',
      Cell: (params: any) => {
        const { original} = params.row
        return (
          <>
            <span className="d-block">{original.place_care_indisa} {original.place_care}</span>
          </>
        )
      }
    },
    {
      accessor: 'action',
      Header: 'Acción',
      width: '15%',
      Cell: (params: any) => {
        const { original } = params.row

        return (
          <div className="d-flex">
            <Button size="sm" onClick={() => onAppointmentCancelModal(original)}>ANULAR / MODIFICAR</Button>
          </div>
        )
      }
    }
  ]

  const appointmentCancel = async (appointmentId: string) => {
    const resp: any = await appointmentService.putAppointmentCancel(appointmentId)

    if(resp && resp.status === 'Ok') {
      modal.setIndex(2)
      if(onDataReload) onDataReload(patientId)

    } else {
      modal.setIndex(3)
    }
  }

  const appointmentShow = (doctorArea: string = '', doctorRut: string = '') => {
    (window as any).show_chat(doctorArea, doctorRut)
  }

  const setDataPageCurrent = (pageCurrent: number) => {
    const rowEnd: number = (pageCurrent * pageSizeDefault) - 1
    const rowIni: number = (rowEnd - pageSizeDefault) + 1

    setDataPage(
      data && data.appointments && data.appointments.length ?
        data.appointments.filter((it: any, i: number) => {
          return i >= rowIni  && i <= rowEnd
        })
      :
        data === '' ? '' : []
    )
  }

  const onAppointmentShow = () => {
    appointmentShow()
  }

  const OpenLightbox = () => {
    const coverLightbox = document.querySelector("#lightbox") as HTMLElement;
    if (coverLightbox) {
      coverLightbox.style.display = "block";
    }
  };

  const onPageCurrent = (pageCurrent: number) => {
    setPageCurrent(pageCurrent)
    setDataPageCurrent(pageCurrent)
  }

  const onAppointmentCancelModal = (appointment: any) => {
    setAppointmentSel({
      id: appointment.id_appointment,
      doctorRut: appointment.rut_professional,
      doctorArea: appointment.cod_specialty
    })
    modal.setIndex(1)
    modal.open()
  }

  const onAppointmentCancel = () => {
    appointmentCancel(appointmentSel.id)
  }

  const onAppointmentReschedule = () => {
    setTimeout(() => {
      modal.close()
    }, 5000);
    appointmentShow(appointmentSel.doctorArea, appointmentSel.doctorRut)
  }

  const onTableMoreShow = (index: number) => {
    setTableItemsShow(prevState => prevState.map((item, idx) => idx === index ? !item : item))
  }

  const onFilterChange = (id: string) => {
    setPatientId(id)
    setPageCurrent(pageDefault)
    if(onDataReload) onDataReload(id)
  }

  return (
    <div className="map-content-mh py-25 lg:px-50">
      <FamilyGroupFilter
        data={familyFilter.data}
        dataSelected={familyFilterSelected}
        onChange={onFilterChange}
      />

      {dataPage ?
          <>
            {dataPage.length ?
                <div className="mt-20">
                  <div className="d-none lg:d-block">
                    <Table
                      columns={tableColumns}
                      data={dataPage}
                    />
                  </div>

                  <div className="d-block lg:d-none">
                    {dataPage.map((it: any, i: number) =>
                      <Card key={i} className={`py-20 px-25 ${i > 0 ? 'mt-20' : ''}`}>
                        <div>
                          <TableLabel>Profesional</TableLabel>
                          <Text component="span" size="14" weight="bold">{it.doctor_name}</Text>
                          <TableText>{it.specialty} - {it.sub_context}</TableText>
                        </div>

                        <div className="mt-10">
                          <TableLabel>Fecha y hora</TableLabel>
                          <TableText>{it.date_mobile}</TableText>
                        </div>

                        {tableItemsShow[i] &&
                          <>
                            <div className="mt-10">
                              <TableLabel>Sucursal</TableLabel>
                              <TableText>{it.place_care_indisa} {it.place_care}</TableText>
                            </div>

                            <div className="mt-20 text-center">
                              <Button onClick={() => onAppointmentCancelModal(it)} style={{ width: 150 }}>ANULAR</Button>
                            </div>
                          </>
                        }

                        {!tableItemsShow[i] &&
                          <div className="text-center mt-25" onClick={() => onTableMoreShow(i)}>
                            <div className="d-inline px-10">
                              <Icon name="arrow-down" />
                            </div>
                          </div>
                        }
                      </Card>
                    )}
                  </div>

                  <div className="text-center mt-20">
                    <Paginate
                      current={pageCurrent}
                      total={data.count_appointment}
                      size={pageSizeDefault}
                      onPageChange={(current) => onPageCurrent(current)}
                    />
                  </div>
                </div>
              :
                <div className="map-content_empty">
                  <Text size="14" weight="semibold" className="lg:fz-20">Aún no tienes próximas horas médicas reservadas</Text>

                  <div className="mt-30 lg:mt-60">
                    <Button color="secondary" size="md" onClick={OpenLightbox}>RESERVA DE HORAS</Button>
                  </div>
                </div>
            }
          </>
        :
          <Loading size="md" align="center" className="pt-70 lg:pt-100" />
      }

      <Modal show={modal.show} maxWidth="345px" onClose={() => modal.close()}>
        {modal.index === 1 &&
          <div className="text-center mx-auto pt-100 pb-80" style={{ maxWidth: '245px' }}>
            <Title component="h4" size="20" weight="bold">¿Estás seguro(a) que deseas anular tu hora médica?</Title>
            <Button fullWidth className="mt-30" onClick={onAppointmentCancel}>ANULAR</Button>
            <Text size="13" className="mt-50">En el paso siguiente podrás reagendar tu hora médica</Text>
          </div>
        }
        {modal.index === 2 &&
          <div className="text-center mx-auto pt-70 pb-60" style={{ maxWidth: '245px' }}>
            <Title component="h4" size="20" weight="bold">¡Tu hora médica ha sido anulada con éxito!</Title>
            <Text weight="semibold" className="mt-25">Si lo deseas, puede reagendar una hora con el mismo profesional</Text>
            <Button fullWidth className="mt-30" onClick={onAppointmentReschedule}>REAGENDAR HORA</Button>
          </div>
        }
        {modal.index === 3 &&
          <FormMessageError
            className="pt-80 pb-70 px-15"
            onClick={() => modal.close()}
          />
        }
      </Modal>
    </div>
  )
}

export { MedicalAppointmentsUpcomings }